import {
	SET_FORM_STATE,
	GET_ANRNBRTRACKING_LAST_UPDATE,
	GET_ANRNBRTRACKING_SITES,
	GET_ANRNBRTRACKING_TABLE,
	GET_NBRRELATIONS_LAST_UPDATE
} from '../actions/AnrNbrTrackingActions';

const initialState = {
	formState: {
		values: {},
		isValid: false,
		touched: {},
		errors: {},
		submit: false
	},
	anrNbrTrackingLastUpdate: '',
	anrNbrTrackingSites: [],
	anrNbrTrackingTableData: [],
	nbrRelationsLastUpdate: '',
};

const anrNbrTrackingReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_ANRNBRTRACKING_LAST_UPDATE: {
						return {
							...state,
							anrNbrTrackingLastUpdate: action.anrNbrTrackingLastUpdate
						};
					}
					case GET_ANRNBRTRACKING_SITES: {
						return {
							...state,
							anrNbrTrackingSites: action.anrNbrTrackingSites
						};
					}
					case GET_ANRNBRTRACKING_TABLE: {
						return {
							...state,
							anrNbrTrackingTableData: action.anrNbrTrackingTableData
						};
					}
					case GET_NBRRELATIONS_LAST_UPDATE: {
						return {
							...state,
							nbrRelationsLastUpdate: action.nbrRelationsLastUpdate
						};
					}
					default: {
						return state;
					}
	}
};

export default anrNbrTrackingReducer;
